/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { FilterConditionDto } from './FilterConditionDto';

export type RuleTemplateNameFilterConditionDto = (FilterConditionDto & {
    operator?: RuleTemplateNameFilterConditionDto.operator;
    ruleTemplateNames?: Array<string>;
} & {
    operator: RuleTemplateNameFilterConditionDto.operator;
    ruleTemplateNames: Array<string>;
});

export namespace RuleTemplateNameFilterConditionDto {

    export enum operator {
        IS = 'IS',
        IS_NOT = 'IS_NOT',
    }


}
